import { TableCell, TableFooter, styled, TableRow } from "@mui/material"
import {lighten } from 'polished'


export const TableCellStyle = styled((props) => {
  return <TableCell {...props}/>
})(({theme}) => ({
  borderLeft: '1px solid rgba(224, 224, 224, 1)', 
  borderRight: '1px solid rgba(224, 224, 224, 1)', 
  padding:"2px",
  textAlign:"center"
}));

export const TableCellImportantStyle = styled((props) => {
  return <TableCellStyle {...props}/>
})(({theme}) => ({
  fontWeight: 'bold',
}));

export const TableCellFirstStyle = styled((props) => {
  return <TableCellStyle {...props}/>
})(({theme}) => ({
  fontWeight: 'bold',
  textAlign:"left"
}));

export const TableCellBottomStyle = styled((props) => {
  return <TableCellStyle {...props}/>
})(({theme}) => ({
  backgroundColor: lighten(0.4,'grey'),
  borderBottom: '1px solid' + theme.palette.primary.main,
}));

export const TableFooterStyle = styled((props) => {
  return <TableFooter {...props}/>
})(({theme}) => ({
  position: 'sticky', 
  bottom: 0, 
}));

export const TableCellFooterStyle = styled((props) => {
  return <TableCellBottomStyle {...props}/>
})(({theme}) => ({
  borderRight: '1px solid' + theme.palette.primary.main,
  fontWeight: 'bold',
  fontSize: "14px"
}));

export const TableRowCustom = styled((props) => 
  <TableRow {...props} />)(({ theme }) => ({
    '&:hover': {
      backgroundColor: '#bde0fe',  
    },
}));
